import React, { Component } from 'react';
import { t } from '../../locales';
import './styles.scss';

interface EmmaLoadingViewProps {
  isLoading: boolean;
}

interface EmmaLoadingViewState {}

export default class EmmaLoadingView extends Component<
  EmmaLoadingViewProps,
  EmmaLoadingViewState
> {
  constructor(props: EmmaLoadingViewProps) {
    super(props);
  }

  render() {
    const { isLoading } = this.props;
    return (
      <div className="emma-loading-view">
        {!!isLoading && (
          <div className="emma-loading-view-hide-bg">
            <div className="emma-stylesheet-loading-blue"></div>
          </div>
        )}
      </div>
    );
  }
}
